import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';

export const Layout = () => {
    return (
        <div className="flex min-h-screen flex-col bg-brand-base text-brand-text">
            <ScrollToTop />
            <Header />
            <main className="flex-1" data-testid="site-main">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
